module.exports = __webpack_public_path__ + "img/logo_big.e0186dc8.jpg";